export default __webpack_public_path__ + "static/media/solteirotriplo_2.17d49668.jpg";